export const getM2MStorageHubDomain = (env?: "production" | "development") => {
  if (env === "production" || globalThis.M2M_COMPONENTS_ENV === "production") {
    return "https://hub.m2msystems.cloud";
  }
  return "https://hub.dev.m2msystems.cloud";
};
